import React, { useState } from 'react'
import VisibilitySensor from 'react-visibility-sensor'
import CountUp from 'react-countup'
import './styles.scss'

export default function DrawingCounterModule({ title, description, items }) {
  const [visible, setVisibility] = useState(false)
  const onChange = visibility => {
    if (visible != true) setVisibility(visibility)
  }
  return (
    <>
      <div className="dhsv-drawing-counter">
        <div className="row">
          <div className="col-12">
            <div className="drawing-counter">
              {title && (
                <h4
                  className="drawing-counter__title"
                  dangerouslySetInnerHTML={{ __html: title }}
                />
              )}
              {description && (
                <div
                  className="drawing-counter__desc"
                  dangerouslySetInnerHTML={{ __html: description }}
                />
              )}
              {items && (
                <div className="drawing-counter__items">
                  {items.map((item, key) => (
                    <div
                      className="drawing-counter__item"
                      key={key}
                      style={{
                        '--counter-color': item.color ? item.color.hex : '#000',
                      }}
                      data-scroll
                    >
                      <div className="drawing-counter__item-circle">
                        <div
                          className="drawing-counter__item-line"
                          style={{
                            '--counter-circle-value': 500 - item.value * 5,
                          }}
                          data-scroll
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="220.197"
                            height="184.92"
                            viewBox="0 0 220.197 184.92"
                            className={'circle-basic'}
                          >
                            <path
                              id="circle-basic"
                              data-name="Path 78"
                              d="M224.174,394.275a108.6,108.6,0,1,1,160.883,1.7"
                              transform="translate(-195.289 -212.079)"
                              fill="none"
                              stroke="#a59c94"
                              strokeWidth="3"
                            />
                          </svg>
                          {item.value && (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="220.197"
                              height="184.92"
                              viewBox="0 0 220.197 184.92"
                              className={'circle-colored'}
                            >
                              <path
                                id="circle-colored"
                                data-name="Path 78"
                                d="M224.174,394.275a108.6,108.6,0,1,1,160.883,1.7"
                                transform="translate(-195.289 -212.079)"
                                fill="none"
                                stroke={item.color ? item.color.hex : '#000'}
                                strokeWidth="3"
                              />
                            </svg>
                          )}
                        </div>
                        {item.icon && (
                          <div className="drawing-counter__item-icon">
                            <img src={item.icon_url} alt={item.icon_alt} />
                          </div>
                        )}
                      </div>
                      {item.value && (
                        <VisibilitySensor partialVisibility onChange={onChange}>
                          <div
                            className="drawing-counter__item-value"
                            style={{
                              height: '60px',
                            }}
                            data-scroll
                          >
                            {visible ? (
                              <CountUp
                                start={'0'}
                                end={item.value}
                                delay={0}
                                duration={2}
                                suffix={`<span class='drawing-counter__item-suffix'>%</span>`}
                              />
                            ) : null}
                          </div>
                        </VisibilitySensor>
                      )}
                      {item.title && (
                        <div
                          className="drawing-counter__item-title"
                          dangerouslySetInnerHTML={{ __html: item.title }}
                        />
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
